var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white text-dark p-1 px-1 px-md-2 px-lg-4" },
    [
      _c(
        "div",
        { staticClass: "d-none d-md-flex align-items-center" },
        [
          _c("p", {
            staticClass: "mb-0",
            domProps: { innerHTML: _vm._s(_vm.currentContractLabel) },
          }),
          _vm._v(" "),
          _vm.showContractSelectorPageLink
            ? [
                _c("p", { staticClass: "mb-0 mx-1" }, [
                  _vm._v("\n                |\n            "),
                ]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "ob1-link-arrow",
                  attrs: {
                    "data-oevent-category": "fiche_option",
                    "data-oevent-action": "changer_de_contrat",
                    href: _vm.contractSelectorPageLinkUrl,
                    "data-oevent-label": _vm.contractSelectorPageLinkUrl,
                  },
                  domProps: {
                    textContent: _vm._s(_vm.contractSelectorPageLinkLabel),
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-block d-md-none text-start" },
        [
          _c("p", {
            staticClass: "mb-0 py-0",
            domProps: { innerHTML: _vm._s(_vm.currentContractLabel) },
          }),
          _vm._v(" "),
          _vm.showContractSelectorPageLink
            ? [
                _c("a", {
                  staticClass: "ob1-link-arrow ob1-link-small pb-0",
                  attrs: {
                    "data-oevent-category": "fiche_option",
                    "data-oevent-action": "changer_de_contrat",
                    href: _vm.contractSelectorPageLinkUrl,
                    "data-oevent-label": _vm.contractSelectorPageLinkUrl,
                  },
                  domProps: {
                    textContent: _vm._s(_vm.contractSelectorPageLinkLabel),
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }